export const SEARCH_MISS_LIST_ATTEMPT = 'SEARCH_MISS_LIST_ATTEMPT';
export const SEARCH_MISS_LIST_SUCCESS = 'SEARCH_MISS_LIST_SUCCESS';
export const SEARCH_MISS_LIST_FAILED = 'SEARCH_MISS_LIST_FAILED';
export const SEARCH_MISS_NEW_ATTEMPT = 'SEARCH_MISS_NEW_ATTEMPT';
export const SEARCH_MISS_NEW_SUCCESS = 'SEARCH_MISS_NEW_SUCCESS';
export const SEARCH_MISS_NEW_FAILED = 'SEARCH_MISS_NEW_FAILED';
export const SEARCH_MISS_WANT_ATTEMPT = 'SEARCH_MISS_WANT_ATTEMPT';
export const SEARCH_MISS_WANT_SUCCESS = 'SEARCH_MISS_WANT_SUCCESS';
export const SEARCH_MISS_WANT_FAILED = 'SEARCH_MISS_WANT_FAILED';
